<template>
  <div class="smart-player" ref="player" :id="'player_' + wnd">
    <div class="player-loading" v-if="playerLoading">
      <div class="player-loading__spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p>等待视频中...</p>
    </div>
    <div class="smart-player__loading" v-if="isError">
      <p>获取流媒体信息异常：{{ errorMessage }}</p>
      <!-- <div>
        <el-button type="primary"
                   @click="close()">关闭</el-button>
        <el-button type="primary"
                   @click="reset">重试</el-button>
      </div> -->
    </div>
    <div
      class="smart-player__close"
      @click="close()"
      v-if="isClose && !showRecord"
    >
      <el-tooltip content="关闭" placement="top">
        <i class="el-icon-close"></i>
      </el-tooltip>
    </div>

    <div class="playRecord" v-if="showRecord">
      <span></span>
      {{ !videoRecordPause ? "视频录制中" : "暂停录制" }}
    </div>
    <div v-if="showRecord" class="smart-player__control">
      <div>
        <el-tooltip content="取消录制" placement="top">
          <i
            v-if="status"
            @click="cancelVideoRecord"
            class="icon-player el-icon-circle-close"
            style="margin-left: 0px"
          ></i>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip
          :content="!videoRecordPause ? '暂停录制' : '继续录制'"
          placement="top"
        >
          <i
            v-if="status"
            class="icon-player"
            @click="pauseVideoRecord"
            :class="
              !videoRecordPause ? 'el-icon-video-pause' : ' el-icon-video-play'
            "
            style="margin-left: 0px"
          ></i>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip content="结束录制" placement="top">
          <i
            v-if="status"
            @click="stopVideoRecord"
            class="icon-player el-icon-circle-check"
            style="margin-left: 0px"
          ></i>
        </el-tooltip>
      </div>
    </div>

    <div class="smart-player__control" v-if="!showRecord">
      <div>
        <el-tooltip content="暂停" placement="top">
          <i
            v-if="status"
            @click="pause"
            class="icon iconfont icon-tingzhi1"
            style="margin-left: 0px"
          ></i>
        </el-tooltip>
        <el-tooltip content="播放" placement="top">
          <i
            v-if="!status"
            @click="play"
            class="el-icon-video-play"
            style="margin-left: 0px"
          ></i>
        </el-tooltip>
      </div>
      <div style="display: flex">
        <div v-for="(buttonIcon, iconIndex) in buttonIconList" :key="iconIndex">
          <el-tooltip
            :content="buttonIcon.name"
            :placement="buttonIcon.type < 5 ? 'top' : 'bottom'"
          >
            <i
              class="icon-player"
              v-if="buttonIcon.type < 5 && showTipIcon(buttonIcon.type)"
              @click.stop="iconClick(buttonIcon.type)"
              :class="buttonIcon.icon"
            ></i>
            <el-popover
              v-if="buttonIcon.type == 5 && showTipIcon(buttonIcon.type)"
              placement="top-end"
              width="188"
              popper-class="showPopper"
              trigger="hover"
            >
              <div>
                <div class="videoInfo">
                  设备名 :
                  <span class="info">
                    {{ deviceInfo.name }}
                  </span>
                </div>
                <div class="videoInfo">
                  分辨率 :
                  <span class="info">
                    {{ resolutionWide || "未知" }} -
                    {{ resolutionHigh || "" }}
                  </span>
                </div>
              </div>
              <i
                class="icon-player"
                :class="buttonIcon.icon"
                @click.stop="iconClick(buttonIcon.type)"
                slot="reference"
              ></i>
            </el-popover>
            <el-popover
              v-if="
                buttonIcon.type == 6 &&
                showTipIcon(buttonIcon.type) &&
                deviceInfo.videoType != 'back'
              "
              placement="top-end"
              width="88"
              popper-class="showPopper"
              trigger="hover"
            >
              <div>
                <el-radio-group v-model="streamType" @change="switchVideoFn">
                  <el-radio
                    :label="false"
                    style="margin-bottom: 7px; color: #fff"
                    >主码流(MAIN)</el-radio
                  >
                  <el-radio :label="true" style="color: #fff"
                    >子码流(SUB)</el-radio
                  >
                </el-radio-group>
              </div>
              <i
                class="icon-player"
                :class="buttonIcon.icon"
                @click.stop="iconClick(buttonIcon.type)"
                slot="reference"
              ></i>
            </el-popover>
          </el-tooltip>
        </div>
      </div>
    </div>

    <video
      ref="video"
      autoplay
      muted
      :id="'video_' + wnd"
      class="smart-player__video"
      :style="{
        width: vW + '%',
        height: vH + '%',
        marginTop: getMarginTop + 'px',
        marginLeft: getMarinLeft + 'px',
      }"
      @mouseover="handleVideoOverEvent"
      @dblclick="toggleFullScreen"
      @mouseleave="handleVideoLeave"
      @mousedown="handleVideoMoveStart($event)"
    ></video>

    <!-- 分享弹窗 -->
    <el-dialog
      title="视频分享"
      class="shareVideo"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="dialogVideo"
      width="645px"
    >
      <div>
        <div class="shareVideoHeader">
          <!-- 分享表单 -->
          <el-form label-position="left" label-width="80px" :model="videoForm">
            <el-form-item label="摄像机">
              <el-input disabled v-model="videoForm.name"></el-input>
            </el-form-item>
            <el-form-item label="分享描述">
              <el-input
                type="textarea"
                placeholder="请输入描述内容"
                maxlength="100"
                show-word-limit
                v-model="videoForm.text"
              ></el-input>
            </el-form-item>
            <div style="color: #999999; text-align: right">
              <span style="color: #ff0033">*该分享视频默认有效期30分钟</span>
            </div>
          </el-form>
        </div>
        <el-divider></el-divider>
        <div class="shareVideoCenter">
          <div class="title">
            <span>选择人员</span>
          </div>
          <div class="serarchTitle">
            <el-row :gutter="24">
              <el-col :span="7">
                <div class="titleS">账户</div>
                <el-input
                  placeholder="请输入"
                  @keyup.enter.native="videoSearchDg(1)"
                  v-model="videoSerch.account"
                ></el-input>
              </el-col>
              <el-col :span="7">
                <div class="titleS">姓名</div>
                <el-input
                  placeholder="请输入"
                  @keyup.enter.native="videoSearchDg(1)"
                  v-model="videoSerch.name"
                ></el-input>
              </el-col>
              <el-col :span="10" style="justify-content: flex-end">
                <el-button type="primary" @click="videoSearchDg(1)"
                  >查询</el-button
                >
                <el-button type="info" @click="videoSearchDg(2)"
                  >重置</el-button
                >
              </el-col>
            </el-row>
          </div>
          <div class="searchTable">
            <el-scrollbar
              :style="{ height: tableData.length > 3 ? '250px' : '150px' }"
            >
              <el-table
                :data="tableData"
                ref="videoTable"
                v-loading="tableLoding"
                element-loading-text="加载中..."
                @selection-change="handleSelectionChange"
                element-loading-spinner="el-icon-loading"
                style="width: 100%"
              >
                <el-table-column type="selection" width="50"> </el-table-column>
                <el-table-column label="序号" type="index" width="60">
                </el-table-column>
                <el-table-column
                  prop="accountNumber"
                  label=" 账户名称"
                  show-overflow-tooltip
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="nickName"
                  label="姓名"
                  show-overflow-tooltip
                  min-width="100"
                >
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80" label="类型"
                  >保卫
                </el-table-column>
                <el-table-column
                  prop="sex"
                  width="80"
                  show-overflow-tooltip
                  label="性别"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.sex === 1
                        ? "男"
                        : scope.row.sex === 0
                        ? "女"
                        : ""
                    }}
                  </template>
                </el-table-column>
              </el-table>
            </el-scrollbar>
            <el-pagination
              class="mt10 mb10 pagination"
              background
              v-if="tableData.length > 0"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[15, 30, 50, 100]"
              :total="Videopage.total"
              :pager-count="5"
              :current-page="Videopage.pageNo"
              @size-change="VideosizeChange"
              @current-change="VideopageChange"
              @prev-click="VideopageChange"
              @next-click="VideopageChange"
            />
          </div>
        </div>
      </div>
      <div slot="footer" class="shareVideoFooter">
        <el-button
          type="primary"
          @click="videoSearchDg(3)"
          :loading="buttonLoding"
          >{{ buttonLoding ? "提交中" : "确定" }}</el-button
        >
        <el-button @click="dialogVideo = false" :loading="buttonLoding">{{
          buttonLoding ? "提交中" : "取消"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 <script type="text/javascript" src="./imosSdk.min.js"></script>
<script>
import busVue from "@/common/utils/busVue";

import FlvPlayer from "flv.js";
import { Cache } from "$utils";
import mixin from "./mixin";
import axios from "axios";
export default {
  name: "SmartPlayer",
  mixins: [mixin],
  props: {
    playUrl: {
      type: String,
      default: "",
    },
    wnd: {
      type: Number,
      default: 1,
    },
    isClose: {
      type: Boolean,
      default: true,
    },
    isBarList: {
      type: Array,
      default: () => {
        return [1, 2, 3, 4, 5, 6, -1, -2];
      },
    },
    videoType: {
      type: String,
      default: "flv",
    },
    deviceInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      resolutionWide: "",
      resolutionHigh: "",
      axiosTimer: null,
      vpnTime: Number(Cache.get("SYS_VPD")) || 120,
      videoRecordPause: false,
      showRecord: false,
      player: null,
      isLive: true,
      status: true,
      zoomStatus: false,
      vW: 100,
      vH: 100,
      zoomStep: 10,
      isOver: false,
      isMove: false,
      moveXDistance: 0,
      moveYDistance: 0,
      marginTop: 0,
      marginLeft: 0,
      mouseWheelRecord: null,
      buttonIconList: [
        { name: "一键抓拍", type: 1, icon: "el-icon-camera-solid" },
        { name: "开启本地录像", type: -2, icon: "el-icon-video-camera" },
        // { name: '结束本地录像', type: -3, icon: 'el-icon-switch-button' },
        { name: "分享", type: 2, icon: "el-icon-share" },
        {
          name: "放大",
          type: 3,
          icon: "el-icon-zoom-in",
        },
        {
          name: "适应窗口",
          type: -1,
          icon: "el-icon-full-screen",
        },
        { name: "全屏显示", type: 4, icon: "security icon-quanping" },
        { name: "设置", type: 6, icon: "el-icon-setting" },
        { name: "视频信息", type: 5, icon: "el-icon-warning-outline" },
      ],
      streamType: false,
      playerLoading: false,
      isError: false,
      errorMessage: "播放失败",
      errorNum: 1,
    };
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  created() {
    this.clearSetTime();
    // this.login();
  },
  mounted() {
    // this.init(); //原有的
    this.initNew(); //9-27 lsy
    let that = this;
    window.onresize = function () {
      if (!that.checkFull()) {
        //触发esc事件，执行业务逻辑。--没有全屏 或者退出全屏
        if (that.showIsFull) {
          that.vW = 100;
          that.vH = 100;
          that.moveXDistance = 0;
          that.moveYDistance = 0;
          that.marginTop = 0;
          that.marginLeft = 0;
          that.showIsFull = false;
        }
      }
    };
    console.log(this.deviceInfo);
  },
  methods: {
    clearSetTime() {
      if (this.axiosTimer) {
        clearInterval(this.axiosTimer);
      }
    },

    checkFull() {
      let eleID = "player_" + this.wnd;
      const el = document.getElementById(eleID);
      const isFull =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      return isFull;
    },
    //  初始化
    init() {
      // console.log(this.deviceInfo)
      this.playerLoading = true;
      if (!FlvPlayer.isSupported()) {
        throw new Error("当前浏览器不支持");
      }
      // 拿到url开始向后台发送请求
      this.vpdAxios();
      // const videoContainer = this.$refs.video;
      this.deviceInfo.streamType == "MAIN"
        ? (this.streamType = false)
        : (this.streamType = true);
      if (!videoContainer) return;
      // type: this.videoType || 'flv',
      // isLive: this.videoType == 'flv' ? this.isLive : false,
      this.player = FlvPlayer.createPlayer(
        {
          type: "flv",
          isLive: this.isLive,
          url: this.playUrl,
          cors: true,
          hasAudio: false,
          withCredentials: false,
        },
        {
          lazyLoadMaxDuration: 60,
          // enableWorker: true,
          seekType: "range",
          fixAudioTimestampGap: false,
          enableStashBuffer: false,
          autoCleanupSourceBuffer: true,
        }
      );
      // this.player.attachMediaElement(videoContainer);
      this.player.on(FlvPlayer.Events.ERROR, (errType, errDetail) => {
        // 清除
        if (this.axiosTimer) {
          clearInterval(this.axiosTimer);
        }
        // errType是 NetworkError时，对应errDetail有：Exception、HttpStatusCodeInvalid、ConnectingTimeout、EarlyEof、UnrecoverableEarlyEof
        // errType是 MediaError时，对应errDetail是MediaMSEError
        console.info("errType", errType);
        console.info("errDetail", errDetail);
        this.isError = true;
        console.log(this.deviceInfo);
        this.handleErrorMessage(errType);
        if (this.deviceInfo.videoType == "back") {
          // 录像失败回调
          this.player.unload();
          this.player.detachMediaElement();
          this.player.destroy();
          this.player = null;
          this.isError = false;
          this.init();
          return;
        }
        // 直播失败回调
        setTimeout(() => {
          if (this.errorNum == 1) {
            this.errorNum += 1;
            this.reset();
          }
        }, 4000);
      });
      this.player.on(FlvPlayer.Events.MEDIA_SOURCE_CLOSE, () => {
        // console.info('媒体源关闭');
      });
      try {
        this.player.load();
        this.player.play();
        setTimeout(() => {
          // console.log(this.player.buffered.end(0));
          // console.log(this.player.buffered.start(0));
          // console.log(this.player.currentTime);
          // console.log(this.player);
          // if (this.player.currentTime < 0.1) {
          // 5秒没反应 重新请求
          // this.reloadVideo()
          // return
          // }
        }, 2000);
        this.status = true;
        // setTimeout(() => {
        // this.playerLoading = false;
        // this.$emit("playSuccess");
        // }, 700);
      } catch (e) {
        setTimeout(() => {
          this.playerLoading = false;
        }, 700);
      }
      this.$nextTick(() => {
        let eleID = "video_" + this.wnd;
        const el = document.getElementById(eleID);
        el.addEventListener("loadedmetadata", (e) => {
          if (e.target.readyState > 0) {
            this.resolutionWide = e.target.videoWidth + "px";
            this.resolutionHigh = e.target.videoHeight + "px";
          }
        });
        el.addEventListener("canplay", (e) => {
          if (this.playerLoading == true) {
            this.playerLoading = false;
            this.$emit("playSuccess");
          }
        });
      });
    },
    //9-27 初始化new
    initNew() {
      console.log("newInit");
      // if (!window.token) {
      //   alert("请先登录");
      //   return;
      // }
      const videoContainer = this.$refs.video;
      if (!videoContainer) return;
      // type: this.videoType || 'flv',
      // isLive: this.videoType == 'flv' ? this.isLive : false,
      //  this.player.attachMediaElement(videoContainer);
      this.player = imosSdk.createPanelWindow();
      if (this.player === null) {
        return;
      }
      try {
        this.player.load();
        this.player.play();
        setTimeout(() => {
          // console.log(this.player.buffered.end(0));
          // console.log(this.player.buffered.start(0));
          // console.log(this.player.currentTime);
          // console.log(this.player);
          // if (this.player.currentTime < 0.1) {
          // 5秒没反应 重新请求
          // this.reloadVideo()
          // return
          // }
        }, 2000);
        this.status = true;
        // setTimeout(() => {
        // this.playerLoading = false;
        // this.$emit("playSuccess");
        // }, 700);
      } catch (e) {
        setTimeout(() => {
          this.playerLoading = false;
        }, 700);
      }
      this.$nextTick(() => {
        let eleID = "video_" + this.wnd;
        const el = document.getElementById(eleID);
        el.addEventListener("loadedmetadata", (e) => {
          if (e.target.readyState > 0) {
            this.resolutionWide = e.target.videoWidth + "px";
            this.resolutionHigh = e.target.videoHeight + "px";
          }
        });
        el.addEventListener("canplay", (e) => {
          if (this.playerLoading == true) {
            this.playerLoading = false;
            this.$emit("playSuccess");
          }
        });
      });
      // createSpeDiv(iframeObj);
    },
    // 暂停
    pause() {
      this.player.pause();
      this.$emit("pause", this.wnd);
      this.status = false;
    },
    // 播放
    play() {
      console.log("play");
      this.player.play();
      this.$emit("play", this.wnd);
      this.status = true;
    },
    // 播销毁播放器放
    close() {
      if (this.axiosTimer) {
        clearInterval(this.axiosTimer);
      }
      this.isError = false;
      this.$emit("close", this.wnd);
      // this.player.unload();
      // this.player.detachMediaElement();
      // this.player.destroy();
      this.$refs.player ? this.$refs.player.remove() : "";
    },
    changeZoomIn() {
      if (this.zoomStatus) {
        this.zoomStatus = false;
        console.info("移除滚轮事件");
        window.removeEventListener("mousewheel", this.handleScroll);
        return;
      }
      if (!this.zoomStatus) {
        this.zoomStatus = true;
      }
      window.addEventListener("mousewheel", this.handleScroll);
    },
    // 滚轮事件监听
    handleScroll(e) {
      let oldDom = document.querySelector("#video_" + this.wnd);
      if (!this.isOver) return;
      let direction = e.deltaY > 0 ? "down" : "up";
      let xh = e.offsetX / oldDom.offsetWidth;
      let yh = e.offsetY / oldDom.offsetHeight;
      if (direction === "up") {
        this.vW += this.zoomStep;
        this.vH += this.zoomStep;
        this.SaveMouseWheelInfo(this.vW);
      } else {
        if (this.vW === 100) return;
        this.vW = this.vW - this.zoomStep;
        this.vH = this.vH - this.zoomStep;
        this.getWheelRecord(this.vW);
        if (this.vW < 100) {
          this.vW = 100;
          this.marginLeft = 0;
          this.moveXDistance = 0;
        }
        if (this.vH < 100) {
          this.vH = 100;
          this.marginTop = 0;
          this.moveYDistance = 0;
        }
      }
      this.$nextTick(() => {
        let newW = document.querySelector("#video_" + this.wnd).offsetWidth;
        let newH = document.querySelector("#video_" + this.wnd).offsetHeight;
        let moveX = newW * xh - e.offsetX;
        let moveY = newH * yh - e.offsetY;
        this.marginTop = Math.round(this.marginTop - moveY);
        this.marginLeft = Math.round(this.marginLeft - moveX);
      });
    },
    getWheelRecord(wheel) {
      if (this.mouseWheelRecord[`wheel_${wheel}`]) {
        const [x, y] = this.mouseWheelRecord[`wheel_${wheel}`];
        // this.marginLeft = x;
        // this.marginTop = y;
        this.mouseWheelRecord[`wheel_${wheel}`] = null;
        delete this.mouseWheelRecord[`wheel_${wheel}`];
      }
    },
    SaveMouseWheelInfo(wheel) {
      if (!this.mouseWheelRecord) {
        this.mouseWheelRecord = {};
      }
      this.mouseWheelRecord[`wheel_${wheel}`] = [
        this.marginLeft,
        this.marginTop,
      ];
    },
    handleVideoOverEvent() {
      this.isOver = true;
    },
    handleVideoLeave() {
      this.isOver = false;
    },
    // 移动视频信息
    handleVideoMoveStart(e) {
      if (!this.zoomStatus) return;
      e.preventDefault();
      const startX = e.clientX;
      const startY = e.clientY;
      this.isMove = true;
      document.querySelector("#video_" + this.wnd).style.cursor = "move";
      // 移动事件
      const moveEvent = (e) => {
        if (!this.isMove) return;
        const _videoElement = document.querySelector("#video_" + this.wnd);
        const _videoH = _videoElement.offsetHeight;
        const _videoW = _videoElement.offsetWidth;
        const _videoBoxElement = document.querySelector("#player_" + this.wnd);
        const _boxW = _videoBoxElement.offsetWidth;
        const _boxH = _videoBoxElement.offsetHeight;
        const _maxY = _videoH - _boxH;
        const _maxX = _videoW - _boxW;
        this.moveXDistance = e.clientX - startX;
        this.moveYDistance = e.clientY - startY;
        if (this.getMarinLeft > 0) {
          this.moveXDistance = -this.marginLeft;
        }
        if (this.getMarginTop > 0) {
          this.moveYDistance = -this.marginTop;
        }
        if (Math.abs(this.getMarinLeft) > _maxX) {
          this.moveXDistance = -(_maxX - Math.abs(this.marginLeft));
        }
        if (Math.abs(this.getMarginTop) > _maxY) {
          this.moveYDistance = -(_maxY - Math.abs(this.marginTop));
        }
      };
      // 移动结束事件
      const moveEnd = (e) => {
        this.isMove = false;
        document.removeEventListener("mousemove", moveEvent);
        document.removeEventListener("mouseup", moveEnd);
        this.marginTop += this.moveYDistance;
        this.marginLeft += this.moveXDistance;
        this.moveXDistance = 0;
        this.moveYDistance = 0;
        document.querySelector("#video_" + this.wnd).style.cursor = "default";
        // 移除事件
      };
      // 注册document鼠标移动事件
      document.addEventListener("mousemove", moveEvent);
      document.addEventListener("mouseup", moveEnd);
    },
    handleErrorMessage(val) {
      switch (val) {
        case "NETWORK_ERROR":
          this.errorMessage = "网络异常";
          break;
        case "MEDIA_ERROR":
          this.errorMessage = "媒体信息异常";
          break;
        default:
          this.errorMessage = " 视频云播放流失败";
      }
      this.$emit("playError", this.errorMessage);
    },
    // 视频重新拉流
    videoReset() {
      this.player.unload();
      this.player.detachMediaElement();
      this.player.destroy();
      this.player = null;
      this.isError = false;
      this.init();
    },
    reset() {
      this.reloadVideo();
    },
  },
  beforeDestroy() {
    // this.close();
    // busVue.$off("sessionVideo");
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.playRecord {
  span {
    display: inline-table;
    border-radius: 8px;
    width: 10px;
    height: 10px;
    background: red;
    animation: fade 600ms infinite;
    -webkit-animation: fade 600ms infinite;
  }
  position: absolute;
  right: 15px;
  top: 15px;
  color: red;
  font-size: 15px;
}
@keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  to {
    opacity: 1;
  }
}
.isFull {
  object-fit: contain !important;
}
.smart-player {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  &__video {
    width: 100%;
    height: 100%;
    background-color: #000;
    object-fit: fill;
  }
  &__loading {
    background-color: #3a3a3a;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
  &__close {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    color: #fff;
    cursor: pointer;
    display: none;
    &:hover {
      background-color: red;
      border-radius: 50%;
    }
  }
  &__control {
    position: absolute;
    width: 100%;
    height: 23px;
    line-height: 23px;
    background: rgba(128, 128, 128, 0.3);
    color: #fff;
    left: 0;
    bottom: -23px;
    z-index: 1;
    padding: 0 10px;
    transition: bottom 0.2s ease-out;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    i {
      margin-left: 10px;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        font-size: 16px;
      }
    }
    .el-tooltip {
      &:hover {
        @include set_theme_color(color, main-theme-color);
      }
    }
  }
  &:hover {
    .smart-player__control {
      bottom: 0px;
    }
    .smart-player__close {
      display: block;
    }
  }
}
.shareVideo {
  /deep/.el-dialog__body {
    padding: 20px 20px 5px !important;
  }
  .el-button--small {
    padding: 6px 13px;
  }
  .shareVideoCenter {
    .title {
      font-size: 16px;
      @include set_theme_color(color, main-theme-color);
      margin-bottom: 15px;
      margin-top: -5px;
    }
    .serarchTitle {
      .titleS {
        width: 45px;
        line-height: 32px;
      }
      .el-col {
        display: flex;
      }
    }
    .searchTable {
      margin-top: 10px;
    }
  }
  .shareVideoFooter {
    text-align: right;
  }
}
</style>
